import React, { useEffect, useState } from "react";

import { manageProjectsTableCols } from "./cols";
import UsersSection from "./UsersSection";
import ExpandableTable from "../Components/expandAbleTable";
import { secondAxios } from "../../../../api/axios";

export default function ManageProjectsPermissionsTab() {
  const [data, setData] = useState([]);
  const [companyUsers, setCompanyUsers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const projectsRes = await secondAxios.get("/project");
      const usersRes = await secondAxios.get("/user/active");

      projectsRes?.data && setData(projectsRes.data);
      usersRes?.data && setCompanyUsers(usersRes.data);
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {};

    fetchData();
  }, []);

  const subSection = (row) => {
    return <UsersSection project={row} companyUsers={companyUsers} />;
  };

  return (
    <ExpandableTable
      entityName="Project"
      tableTitle="Project Management"
      data={data}
      setData={setData}
      cols={manageProjectsTableCols}
      subSection={subSection}
    />
  );
}
